import { useEffect, useState } from "react";
import { get } from "../lib/api";
import { usePageMeta } from "../hooks/useData";
import { t } from "../lib/i18n";
import { Hero, HERO_DEFAULTS } from "../components/home/Hero";
import { ManifestoBand } from "../components/home/Bands";
import { ShareFloor } from "../components/home/ShareFloor";
import { ServicesFloor } from "../components/home/ServicesFloor";
import { AskFloor } from "../components/home/AskFloor";
import { NewsFloor } from "../components/home/NewsFloor";
import { CompaniesFloor } from "../components/home/CompaniesFloor";
import { MarketsFloor } from "../components/home/MarketsFloor";
import { MapFloor } from "../components/home/MapFloor";
import { JoinFloor, CareerFloor } from "../components/home/JoinFloor";

export default function Home() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  usePageMeta(t("EQVA ASA – EQVA bygger sterke industriselskaper"), t("EQVA bygger sterke industriselskaper. Børsnotert industrikonsern med hovedkontor i Sunde i Sunnhordland."));
  useEffect(() => {
    get("/home").then(setData).catch(() => setError(true));
  }, []);

  if (error) return <div className="wrap pt-40 pb-20" data-testid="home-error"><p>{t("Kunne ikke laste innholdet. Prøv igjen senere.")}</p></div>;

  return (
    <div data-testid="home-page" aria-busy={!data}>
      {/* The hero paints immediately from defaults; the floors below arrive with the data. */}
      <Hero settings={data?.settings} />
      {/* Reserve room for the floors while /api/home loads, so the footer (and its images) stays far below the fold. */}
      {!data && <div className="min-h-[150vh] bg-white" aria-hidden="true" />}
      {data && (
        <>
          <ManifestoBand settings={data.settings} stats={data.settings?.stats || HERO_DEFAULTS.stats} />
          <ShareFloor figures={data.key_figures} />
          <ServicesFloor services={data.services} />
          <AskFloor />
          <NewsFloor articles={data.articles} />
          <CompaniesFloor companies={data.companies} />
          <MapFloor />
          <MarketsFloor markets={data.markets} />
          <JoinFloor settings={data.settings} />
          <CareerFloor settings={data.settings} />
        </>
      )}
    </div>
  );
}
